import { Card, Typography } from "antd";
import { useParams } from "next/navigation";
import React, { useEffect } from "react";
import { useIntl } from "react-intl";
import { _eventBus } from "../../core/events/EventBus";
import {
  isEmpty,
  isWithoutBookingServiceRequest,
} from "../../Lib/Utils/validationUtil";
import { srReqClaimTree } from "../../Orchestrator/ConstantTree/ServiceRequestClaim/ServiceRequestClaim";
import { useRecState } from "../../Orchestrator/Recoils/Events/Recoil";
import {
  IAdditionalField,
  ISelectedCategoryAndSubCategory,
} from "../../Orchestrator/Types/Interface/IServiceRequest";
import DynamicForm from "../DynamicForm/DynamicForm";

const ServiceRequestFields: React.FC = () => {
  const params = useParams();
  const intl = useIntl();
  const [selectedCategoryAndSubCategory] =
    useRecState<ISelectedCategoryAndSubCategory>(
      "selectedCategoryAndSubCategoryAtom"
    );
  const [additionalFields] = useRecState<IAdditionalField[]>(
    "additionalFieldsAtom"
  );
  const [selectedTripForServiceRequest] = useRecState<string[]>(
    "selectedTripForServiceRequestAtom"
  );

  useEffect(() => {
    if (checkCatAndSubCate()) {      
      _eventBus.emit({
        eventName: srReqClaimTree.RequestClaim.setFields,
      });
    }
  }, [
    selectedCategoryAndSubCategory.category,
    selectedCategoryAndSubCategory.subCategory,
  ]);

  const checkCatAndSubCate = () => {
    return (
      !isEmpty(selectedCategoryAndSubCategory.category) &&
      !isEmpty(selectedCategoryAndSubCategory.subCategory)
    );
  };
  const checkTrainSelected = () => {
    return selectedTripForServiceRequest.length !== 0;
  };

  const isOnlyServiceRequest: boolean = isWithoutBookingServiceRequest(
    (params?.booking_id || "") as string
  );

  const validateData = () => {
    const isCategoryAndSubCategory = checkCatAndSubCate();
    if (isOnlyServiceRequest) return isCategoryAndSubCategory;
    else {
      const isTripSelected = checkTrainSelected();
      return isCategoryAndSubCategory && isTripSelected;
    }
  };

  return (
    <Card
      className={
        validateData()
          ? "right-card"
          : "right-card no-cat-select justify-content-center"
      }
    >
      {validateData() ? (
        <DynamicForm additionalFields={additionalFields} />
      ) : (!checkTrainSelected() && !isOnlyServiceRequest) ? (
        <Typography.Title
          level={4}
          className="ff-inter fs-18 fw-700 color-2F3034 text-center m-0"
        >
          {intl.formatMessage({ id: "selectTripToSR" })}
        </Typography.Title>
      ) : !checkCatAndSubCate() ? (
        <Typography.Title
          level={4}
          className="ff-inter fs-18 fw-700 color-2F3034 text-center m-0"
        >
          {intl.formatMessage({ id: "pleaseSelectCategoryTextFirst" })}
          <br></br>
          {intl.formatMessage({ id: "pleaseSelectCategoryTextSecond" })}
        </Typography.Title>
      ) : (
        <></>
      )}
    </Card>
  );
};

export default ServiceRequestFields;
